// extracted by mini-css-extract-plugin
module.exports = {"title":"TradingViewTools_title__Gwyw3"};